import React from "react";

import ResetPasswordFeature from "../features/auth/forgotPassword/ResetPassword";

function ResetPassword(props) {
  return <ResetPasswordFeature {...props} />;
}

export default ResetPassword;
